<template>
    <div class="content_con">
        <p class="text-center"><span class="title">东进公司消杀药品、消杀用品、防护用品</span></p>
        <p class="text-center margin-bottom-21"><span class="title">及岗位承包采购项目询价公告</span></p>
        <p class="text-indent-37 line-height-39">
            <span
                class="content">广东东进有害生物防控技术有限公司业务范围主要包括常规四害防制、林业有害生物防制、常规白蚁防制、空气治理（除甲醛除臭除味）、常规空调/集中空调通风系统清洗、光伏板清洗、生活水箱清洗、专业油烟管道清洗、工业商业循环水处理、出入境检疫消杀消毒处理、熏蒸消毒处理、集装箱消毒、船舶底部海洋生物清洗、红火蚁防制、水利白蚁防制等。根据业务需要，公司计划对消杀药品、消杀用品、防护用品及岗位承包服务进行采购，现将相关情况介绍如下：</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">一、项目信息</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、项目名称：<span class="underline">广东东进有害生物防控技术有限公司消杀药品、消杀用品、防护用品及岗位承包采购项目；</span></span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span>、项目编号：</span>
            <span>DJFK-XS-05-08-001</span>
            <span>（</span>
            <span>2024</span>
            <span>）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">3</span>
            <span class="content">、采购范围：<span class="underline">消杀药品、消杀用品、防护用品及岗位承包等；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">4</span>
            <span class="content">、项目地点：<span class="underline">采购人指定交货地址；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">5</span>
            <span class="content">、服务时间（供货时间</span>
            <span class="content">/</span>
            <span class="content">工期）：<span class="underline">合同签订日起订</span></span>
            <span class="underline"><span class="number">2</span></span>
            <span class="underline"><span class="content">年；</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">二、项目要求</span></p>
        <p class="text-left text-indent-37 line-height-39"><span class="content">详见招标文件。</span></p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">三、项目发布</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、本项目在东莞实业投资控股集团有限公司</span>
            <span class="content">-</span>
            <span class="content">招标采购栏目：</span>
            <span class="content">
                <a class="fa"
                    href="http://www.dgsy.com.cn/%E5%8F%91%E5%B8%83%E3%80%82">http://www.dgsy.com.cn/发布。</a></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">2</span>
            <span class="content">、网上公示期限为</span>
            <span class="number">8</span>
            <span class="content">天，即</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">8</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">8</span></span>
            <span class="underline"><span class="content">日至</span></span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">8</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">15</span></span>
            <span class="underline"><span class="content">日</span></span>
            <span class="content">。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">四、响应人资格要求</span></p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">1</span>
            <span
                class="content">、响应人须为在中华人民共和国境内登记注册的具有独立承担民事责任能力的法人或其他组织。【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】；</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">2</span>
            <span class="content">、未被列入东实集团及下属企业相关领域黑名单。【以东莞实业投资控股集团有限公司发文（东实通〔</span>
            <span class="number">2021</span>
            <span class="content">〕</span>
            <span class="number">44</span>
            <span class="content">号）、（东实通〔</span>
            <span class="number">2021</span>
            <span class="content">〕</span>
            <span class="number">98</span>
            <span class="content">号）、（东实通〔</span>
            <span class="number">2022</span>
            <span class="content">〕</span>
            <span class="number">75</span>
            <span class="content">号）（东实通〔</span>
            <span class="number">2023</span>
            <span class="content">〕</span>
            <span class="number">37</span>
            <span class="content">号）为准，如有最新发文通知，按最新文件执行。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">3</span>
            <span class="content">、供应商未被列入</span>
            <span class="content">“</span>
            <span class="content">信用中国</span>
            <span class="content">”</span>
            <span class="content">网站（</span>
            <span class="content">https://www.creditchina.gov.cn/)“</span>
            <span class="content">记录失信被执行人或重大税收违法案件当事人名单或政府采购严重违法失信行为</span>
            <span class="content">”</span>
            <span class="content">记录名单；同时，不处于中国政府采购网（</span>
            <span class="content">http://www.ccgp.gov.cn/</span>
            <span class="content">）</span>
            <span class="content">“</span>
            <span class="content">政府采购严重违法失信行为信息记录</span>
            <span class="content">”</span>
            <span class="content">中的禁止参加政府采购活动期间；以及未被工商行政管理机关在</span>
            <span class="content">“</span>
            <span class="content">国家企业信用信息公示系统</span>
            <span class="content">”</span>
            <span class="content">网站（</span>
            <span class="content">www.gsxt.gov.cn</span>
            <span class="content">）中列入严重违法失信企业名单；（需提供以上网址网上查询认证渠道截图，截图必须显示供应商单位名称并加盖公章。）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">五、开标时间及开标地址</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">投标文件递交截止时间：</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">8</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">16</span></span>
            <span class="underline"><span class="content">日上午</span></span>
            <span class="underline"><span class="number">09:30</span></span>
            <span class="content">（星期五）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">开标时间：</span>
            <span class="underline"><span class="number">2024</span></span>
            <span class="underline"><span class="content">年</span></span>
            <span class="underline"><span class="number">8</span></span>
            <span class="underline"><span class="content">月</span></span>
            <span class="underline"><span class="number">16</span></span>
            <span class="underline"><span class="content">日上午</span></span>
            <span class="underline"><span class="number">09:30</span></span>
            <span class="content">（星期五）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">开标地址：<span class="underline">东莞市南城街道中天商业街</span></span>
            <span class="underline"><span class="number">28</span></span>
            <span class="underline"><span class="content">号</span></span>
            <span class="underline"><span class="number">1</span></span>
            <span class="underline"><span class="content">栋</span></span>
            <span class="underline"><span class="number">209</span></span>
            <span class="underline"><span class="content">室东进公司</span></span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">联系人：翟智伟（</span>
            <span class="number">13829104552</span>
            <span class="content">）</span>
        </p>
        <h2 class="text-indent-37 line-height-39">
            <span style="font-weight: normal;" class="content">详细需求请见附档文件。</span>
        </h2>
        <p class="text-indent-243 line-height-39">
            <span class="content">&nbsp;</span>
        </p>
        <p class="text-center text-indent-243 line-height-39">
            <span class="content">广东东进有害生物防控技术有限公司</span>
        </p>
        <p class="text-center text-indent-336 line-height-39">
            <span class="number">2024</span>
            <span class="content">年</span>
            <span class="number">8</span>
            <span class="content">月</span>
            <span class="number">8</span>
            <span class="content">日</span>
        </p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"></a><a
                class="file-link" href="/20240823/东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.docx"
                title="东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.docx">东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.docx</a></p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"></a><a
                class="file-link" href="/20240823/东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.pdf"
                title="东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.pdf">东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价文件.pdf</a></p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"></a><a
                class="file-link" href="/20240823/东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价公告.pdf"
                title="东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价公告.pdf">东进公司消杀药品、消杀用品、防护用品及岗位承包采购项目询价公告.pdf</a></p>
    </div>
</template>
<script>
export default {
    name: "DocDisplay"
};
</script>

<style lang="scss" scoped>
.content_con {
    font-size: 14px;
    font-family: "宋体", Arial;
    padding: 0px 50px;
    color: #515050;

    a {
        text-decoration: none;
        color: inherit;
    }

    .fa {
        color: #333;
        font-size: 12px;
    }

    .line-height-2em {
        line-height: 2em;
    }

    .text-center {
        text-align: center;
    }

    .margin-bottom-21 {
        margin-bottom: 21px;
    }

    .title {
        font-size: 27px;
        font-family: 方正小标宋简体;
    }

    .text-indent-37 {
        text-indent: 37px;
    }

    .line-height-39 {
        line-height: 39px;
    }

    .content {
        font-weight: 200;
        font-size: 19px;
        font-family: 仿宋_GB2312;
    }

    .heading {
        font-size: 19px;
        font-family: 黑体;
    }

    .number {
        font-size: 19px;
        font-family: 'Times New Roman', 'serif';
    }

    .underline {
        text-decoration: underline;
    }

    .text-left {
        text-align: left;
    }

    .text-autospace {
        margin: 3px;
        padding: 3px;

        span {
            color: #515050;
            font-size: 14px !important;
        }
    }

    .icon {
        vertical-align: middle;
        margin-right: 2px;
    }

    .file-link-box {
        margin: 3px;
        padding: 3px;
        font-size: 14px;
        text-indent: 22px;
        line-height: 16px;
    }

    .file-link {
        font-size: 12px;
        color: #0066cc;
    }
}
</style>